import styled from "styled-components";
import { getUserDisplayName } from "../userAdministrationUtils";
import theme from "../../../../../UI/theme";
import { ButtonRowContainer } from "../../../../panel/ModalStyles";
import UpdateSharedAccountPasswordButton from "./UpdateSharedAccountPasswordButton";
import { SettingsParagraph, SettingsSection } from "../../../settingsStyles";

const Container = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 10px;
`

const HighlightedSpan = styled.span`
    color: ${theme.colors.whiteSpace};
`

const Header = styled.h3`
    color: ${theme.colors.whiteSpace};
    margin: 0;
`

const SharedAccountParagraphContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px 0;
`

const UserInfo = ({ user }) => {
    return <Container>
        <Header>{getUserDisplayName(user)}</Header>

        <SettingsSection style={{marginBottom: "20px"}}>
            {(user?.shared === 1)? <>
                <SharedAccountParagraphContainer>
                    <SettingsParagraph style={{fontSize: "14px", color: theme.colors.whiteSpace}}>This is a shared account</SettingsParagraph>
                </SharedAccountParagraphContainer>
                <SettingsParagraph>Username: <HighlightedSpan>{user?.username}</HighlightedSpan></SettingsParagraph>
            </> : <>
                <SettingsParagraph>Title: <HighlightedSpan>{user?.title}</HighlightedSpan></SettingsParagraph>
                <SettingsParagraph>Phone: <HighlightedSpan>{user?.phone}</HighlightedSpan></SettingsParagraph>
                <SettingsParagraph>Email: <HighlightedSpan>{user?.email}</HighlightedSpan></SettingsParagraph>
            </>}
            <br/>
            <SettingsParagraph>Account status: <HighlightedSpan>{user?.accountStatus}</HighlightedSpan></SettingsParagraph>
            <SettingsParagraph> Created:{" "}
                <HighlightedSpan>
                    {user?.createdOn
                    ? new Date(user.createdOn).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                        })
                    : "Unknown"}
                </HighlightedSpan>
            </SettingsParagraph>
        </SettingsSection>

        {user?.shared === 1 ? <>
            <ButtonRowContainer>
                <UpdateSharedAccountPasswordButton user={user} />
            </ButtonRowContainer>
        </> : <></>}
    </Container>
}

export default UserInfo;